const data = {
  heading: "Connecting Science With Community",
  subHeading:
    " We develop and support an interdisciplinary life sciences community in Pakistan through education, outreach and activism.",
};

export default data;
